module.exports = {"film":{"label":"Film","icon":"film"},"film-series":{"label":"Film series","icon":"film"},"photographs":{"label":"Photographs","icon":"photographs"},"interactive":{"label":"Interactive","icon":"interactive"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/tags.yaml
// module id = 508
// module chunks = 1474